import { userFeature } from './user.reducer'

export const { selectUserName } = userFeature
